import { Box } from '@mui/material';
import { WidgetOption } from './WidgetSelector';
import { NumericInput } from '../NumericInputField';

type BackpressureDist = Models.SetsPlayground.BackpressureSetDistribution;

interface Props {
    value: BackpressureDist;
    onChange: (next: BackpressureDist) => void;
}

const BackpressureDistributionWidgetComponent = ({ value, onChange }: Props): JSX.Element => {
    const handlePart = (newValue: number | undefined): void => {
        onChange({ ...value, part: newValue ?? 0 });
    };

    const handleOffset = (newValue: number | undefined): void => {
        onChange({ ...value, offset: newValue });
    };

    const handleLimit = (newValue: number | undefined): void => {
        onChange({ ...value, limit: newValue });
    };

    return (
        <Box display="grid" gap={2} gridTemplateColumns={{ xs: '1fr', sm: 'repeat(3, 1fr)' }}>
            <NumericInput
                allowDecimals
                required
                label="Probability (0–1)"
                max={1}
                min={0}
                value={value.part}
                onChange={handlePart}
            />
            <NumericInput
                label="Offset"
                min={0}
                placeholder="Value is zero indexed"
                value={value.offset}
                onChange={handleOffset}
            />
            <NumericInput
                label="Limit"
                min={0}
                value={value.limit}
                onChange={handleLimit}
            />
        </Box>
    );
};

export const BackpressureDistributionWidget: WidgetOption<BackpressureDist> = {
    label: 'Backpressure Distribution',
    value: 'backpressure',
    helperText: 'Configure backpressure distribution settings with part, offset, and limit.',
    component: BackpressureDistributionWidgetComponent,
    getDefaultValue: () => ({
        type: 'backpressure',
        part: 0.5,
    }),
};
